import React, { useEffect, useContext, useState } from 'react';
import PropTypes from 'prop-types';
import FlatsFiltersRange from '../FlatsFiltersRange/FlatsFiltersRange';
import { IEvent } from '../../Plans/analytics';
import {
  USD_DEFAULT_FULL_RANGE,
  USD_MIN_FULL_RANGE_STEP,
  USD_MIN_SQM_RANGE_STEP,
  MIN_FULL_RANGE_STEP,
  MIN_SQM_RANGE_STEP,
  DEFAULT_FULL_RANGE,
  ONE_MILLION,
  fullRange,
  scaleToPrice,
  sqmRange,
} from '../../Funnel/FunnelPrice/rangeHelper';
import { FlatsFiltersContentContext } from '../FlatsFiltersContext';

const FlatsFiltersPriceRange = ({
  type,
  rangeMin,
  rangeMax,
  event,
  minValue,
  maxValue,
  isFullRange,
}) => {
  const { currency } = useContext(FlatsFiltersContentContext);
  const minUah =
    rangeMin >= ONE_MILLION ? (rangeMin / ONE_MILLION).toFixed(2) * ONE_MILLION : rangeMin;
  const maxUah =
    rangeMax >= ONE_MILLION ? (rangeMax / ONE_MILLION).toFixed(2) * ONE_MILLION : rangeMax;
  const minUsd = Math.round(rangeMin / window.currencyRateUSD);
  const maxUsd = Math.round(rangeMax / window.currencyRateUSD);
  const uahRange = isFullRange
    ? fullRange(minUah, maxUah, DEFAULT_FULL_RANGE, MIN_FULL_RANGE_STEP)
    : sqmRange(minUah, maxUah, MIN_SQM_RANGE_STEP);
  const usdRange = isFullRange
    ? fullRange(minUsd, maxUsd, USD_DEFAULT_FULL_RANGE, USD_MIN_FULL_RANGE_STEP)
    : sqmRange(minUsd, maxUsd, USD_MIN_SQM_RANGE_STEP);
  const [range, setRange] = useState(uahRange);
  const [rangeValues, setRangeValues] = useState([minUah, maxUah]);
  const [initialValues, setInitialValues] = useState([
    minValue === rangeMin ? minUah : minValue,
    maxValue === rangeMax ? maxUah : maxValue,
  ]);

  const onCurrencyChange = (values) => {
    const isUsd = currency === 'usd';
    let [min, max] = scaleToPrice(values, isUsd ? minUah : minUsd, isUsd ? maxUah : maxUsd);
    if (isUsd) {
      min = min !== minUah ? Math.round(min / window.currencyRateUSD) : minUsd;
      max = max !== maxUah ? Math.round(max / window.currencyRateUSD) : maxUsd;
    } else {
      min = min !== minUsd ? Math.round(min * window.currencyRateUSD) : minUah;
      max = max !== maxUsd ? Math.round(max * window.currencyRateUSD) : maxUah;
    }

    setInitialValues([min, max]);
  };

  useEffect(() => {
    if (currency === 'usd') {
      setRangeValues([usdRange.min[0], usdRange.max[0]]);
      setRange(usdRange);
    } else {
      setRangeValues([uahRange.min[0], uahRange.max[0]]);
      setRange(uahRange);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currency]);

  useEffect(() => {
    if (currency === 'usd') {
      setInitialValues([
        minValue === rangeMin ? minUsd : Math.round(minValue / window.currencyRateUSD),
        maxValue === rangeMax ? maxUsd : Math.round(maxValue / window.currencyRateUSD),
      ]);
    } else {
      setInitialValues([
        minValue === rangeMin ? minUah : minValue,
        maxValue === rangeMax ? maxUah : maxValue,
      ]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [minValue, maxValue]);

  return (
    <FlatsFiltersRange
      type={type}
      range={range}
      rangeMin={rangeValues[0]}
      rangeMax={rangeValues[1]}
      minValue={initialValues[0]}
      maxValue={initialValues[1]}
      event={event}
      onCurrencyChange={onCurrencyChange}
      isPriceFilter
    />
  );
};

FlatsFiltersPriceRange.propTypes = {
  type: PropTypes.string.isRequired,
  event: PropTypes.shape(IEvent).isRequired,
  rangeMin: PropTypes.number.isRequired,
  rangeMax: PropTypes.number.isRequired,
  minValue: PropTypes.number.isRequired,
  maxValue: PropTypes.number.isRequired,
  isFullRange: PropTypes.bool,
};

export default FlatsFiltersPriceRange;
